import { Editor, generateHTML, generateJSON, JSONContent } from '@tiptap/core'
import ExtensionKit from '../extensions/extension-kit.js'

export const extractTiptapJson = (markdownValue: string) => {
  const editor = new Editor({
    content: markdownValue,
    extensions: [
      ...ExtensionKit({
        openAssetHQHandler: () => {},
        // provider,
      }),
    ],
  })
  return editor.getJSON()
}

export const extractTiptapJsonFromHTML = (htmlinput: string) => {
  return generateJSON(htmlinput, [
    ...ExtensionKit({
      openAssetHQHandler: () => {},
      // provider,
    }),
  ])
}

export const extractMarkdown = (json: any) => {
  const editor = new Editor({
    content: json,
    extensions: [
      ...ExtensionKit({
        // provider,
        openAssetHQHandler: () => {},
      }),
    ],
  })
  const markdown = editor.storage.markdown.getMarkdown()
  return markdown
}

export const getHtml = (json: JSONContent) => {
  // const editor = new Editor({
  //   content: json,
  //   extensions: [
  //   ,
  //   ],
  // });

  return generateHTML(json, [
    ...ExtensionKit({
      // provider,
      openAssetHQHandler: () => {},
    }),
  ])
}
